import React from 'react';
import { BACKEND_URL } from '../../../../../variables';

interface Props {
    id?: number;
    path?: string;
    onLoad?:() => void;
}

const PdfDocument: React.FC<Props> = (props: Props) => {
    const { path, onLoad } = props;

    return (
        <div>
            <iframe
                src={`${BACKEND_URL}/publications/pdf${path?.slice(0, -3) + 'pdf' ? `?path=${path?.slice(0, -3) + 'pdf'}` : ''}`}
                title="PDF Document"
                style={{ width: '100%', height: '800px' }}
                onLoad={onLoad}
            />
        </div>
    );
};

export default PdfDocument;
